export default "__VITE_ASSET__D4NH61kP__"